import styled from "styled-components"

const StyledSection = styled.section`
  display: block;
  padding-top: 3rem;
  padding-bottom: 3rem;
  background-color: ${props => props.backgroundColor ? props.backgroundColor : '#f8f8f8'};
  
`

export default StyledSection;
